export {}

type Nullable<T>	= T|null;
const unsafeGet	= <T>(self:Nullable<T>):T	=> {
	if (self === null)	throw new Error("unexpected null");
	return self;
};

const modal				= document.querySelector('.js-modal');
const buttonNext:HTMLButtonElement		= unsafeGet(document.querySelector(".js-nav-button-next"));
const buttonPrevious:HTMLButtonElement	= unsafeGet(document.querySelector(".js-nav-button-previous"));
const closeButton		= document.querySelector('.js-close');
const thumbnailsDivs	= Array.from(document.getElementsByClassName('js-thumbnails'));
const screenshotsDiv	= document.querySelector('.js-screenshots');
const dotsDiv			= document.querySelector('.js-dot-navigation');

const previousImage	= () => activateScreenshot(getActive() - 1);
const nextImage		= () => activateScreenshot(getActive() + 1);


const getChildren = (element: Element | null) =>
	element !== null
		? Array.from(element.children)
		: [];

const getActive = () =>
	getChildren(screenshotsDiv).findIndex(
		screenshot => screenshot.classList.contains("active")
	);

const show = (elem: Element | null) => {
	if(elem !== null)
		elem.classList.remove("hidden");
	console.log("show", elem);
}

const hide = (elem: Element | null) => {
	if(elem !== null)
		elem.classList.add("hidden");
	console.log("hide", elem);
}

const checkModal = (target:HTMLElement):boolean => {
	if (modal === null || screenshotsDiv === null || dotsDiv === null || target === null) return false;

	//remove all old screenshot and dot elements
	screenshotsDiv.innerHTML = '';
	dotsDiv.innerHTML ='';

	const thumbnailsDiv		= (target.tagName === "IMG")	? target.parentElement	: target;
	const thumbnailClicked	= (target.tagName === "IMG")	? target				: null;

	if(thumbnailsDiv === null) return false;

	const thumbnails = Array.from(thumbnailsDiv.children);
	thumbnails.forEach((thumb, index) => {
		const url	= thumb.getAttribute("src") ?? "";
		const title	= thumb.getAttribute("alt") ?? "";

		//create new screenshot element
		const img = document.createElement("image");
		img.setAttribute ("src", url.replace("referenzen_thumb", "referenzen"));
		img.setAttribute ("alt", title);
		img.classList.add("screenshot");
		if(thumb.classList.contains("thumbnail--borderless")) {
			img.classList.add("screenshot--borderless");
		}
		screenshotsDiv.appendChild(img);

		//create new dot element
		const dotButton = document.createElement("button");
		dotButton.addEventListener("click", () => activateScreenshot(index));
		dotButton.classList.add("dot");
		const li = document.createElement("li");
		li.appendChild(dotButton);
		dotsDiv.appendChild(li);
	});

	//ugly, but needed to reload screenshotsDiv after changing images
	const content = screenshotsDiv.innerHTML;
	screenshotsDiv.innerHTML = content;

	const indexOfActive = thumbnailClicked === null
		? 0
		: thumbnails.findIndex(thumbnail =>
			thumbnailClicked.getAttribute("src") === thumbnail.getAttribute("src"));
	activateScreenshot(indexOfActive);
	return true;
};

const initialize = () => {
	const isMobile = !window.matchMedia('only screen and (max-width: 840px)').matches;
	if(!isMobile) return;

	if(closeButton !== null)
		closeButton.addEventListener("click", () =>
			hide(modal));

	window.addEventListener("click", (event) => {
		if (event.target === modal)
			hide(modal);
	});

	buttonNext.addEventListener("click", nextImage);
	buttonPrevious.addEventListener("click", previousImage);

	for(const thumbnailsDiv of thumbnailsDivs) {
		thumbnailsDiv.addEventListener("click", (event) => {
			if (checkModal(event.target as HTMLElement))
				show(modal);
		});

		const thumbnails = Array.from(thumbnailsDiv.children);
		for(const thumbnail of thumbnails) {
			thumbnail.addEventListener("click", (event) => {
				if (checkModal(event.target as HTMLElement))
					show(modal);
			});
		}
	}
}

const activateScreenshot = (index:number) => {
	const screenshots = getChildren(screenshotsDiv);
	for (const screenshot of screenshots) {
		screenshot.classList.remove("active");
	}
	screenshots[index].classList.add("active");
	screenshots[index].nextElementSibling		!== null ? buttonNext.removeAttribute("disabled")		: buttonNext.setAttribute("disabled", "");
	screenshots[index].previousElementSibling	!== null ? buttonPrevious.removeAttribute("disabled")	: buttonPrevious.setAttribute("disabled", "");

	const dots = getChildren(dotsDiv);
	for (const dot of dots) {
		dot.classList.remove("active");
	}
	dots[index].classList.add("active");
}

initialize();
